import React from 'react';
import { ProviderConsumer } from '@fluentui/react-northstar';

// The loading bar at the top of a list's scroll area, or across the top of a board, while its rows or cards
// reload in place (tikit-refresh-bar in main.css). It sits outside the list, where the theme's colour variables
// are not set, so it takes the brand colour from the theme itself.
export const RefreshBar = ({ board, style }: { board?: boolean; style?: React.CSSProperties }) => (
  <ProviderConsumer render={globalTheme => (
    <div
      className={`tikit-refresh-bar${board ? ' tikit-refresh-bar--board' : ''}`}
      style={{ '--mgt-theme-brand-foreground': globalTheme.siteVariables.colorScheme.brand.foreground, ...style } as React.CSSProperties}
    />
  )} />
);
